import { render, staticRenderFns } from "./berechnungen.vue?vue&type=template&id=cfdf5578&"
import script from "./berechnungen.vue?vue&type=script&lang=js&"
export * from "./berechnungen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports